"use client";

import React from "react";

const EmbeddedVideo = ({ EmbeddedVideoiFrame, size, alignment }) => {
  return (
    <div
      className={`tps-video-frame-wrapper ${
        size === "Default" ? "tps-video-default" : "tps-video-large"
      } tps-float-medium ${
        alignment === "Left"
          ? "tps-float-left"
          : alignment === "Right"
            ? "tps-float-right"
            : "tps-float-center"
      }`}
      dangerouslySetInnerHTML={{ __html: EmbeddedVideoiFrame }}
    ></div>
  );
};

export default EmbeddedVideo;
